import { Box, Stack, useTheme } from '@mui/joy';
import ImageExportUtility from './ImageExportUtility';
import CopyToClipboardUtility from './CopyToClipboardUtility';
import { ReactNode } from 'react';

interface IProps {
	component: ReactNode;
	title: string | ReactNode;
	page: string;
}

const ChartUtilities = ({ component, title, page }: IProps) => {
	const theme = useTheme();
	return (
		<Stack
			direction='column'
			alignItems='flex-end'
			sx={{
				backgroundColor: theme.palette.chartElementsBackground.bg,
				paddingBottom: '.25rem'
			}}
		>
			<Stack direction='row' alignItems='center'>
				<ImageExportUtility component={component} title={title} page={page} />
				<Box
					sx={{
						width: '1px',
						height: '2rem',
						borderLeft: '1px solid gray'
					}}
				/>
				<CopyToClipboardUtility />
			</Stack>
		</Stack>
	);
};

export default ChartUtilities;
